
import * as HelpVideos from '../../../@resources/help';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { HelpController } from '../../core/help/HelpController';

export const haugOpenVideo = defineCommand(
    'haugOpenVideo',
    null,
    (r, [key, ...opts]: [string, ...['force' | 'append']]) => {

        const lib = Object.values(HelpVideos);
        const ctrl = r.call(HelpController);


        const vid = lib.find(x => x.key === key);
        if (vid) {
            ctrl.openVideo(vid);
        }
    }
);

export const haugDismissVideo = defineCommand(
    'haugDismissVideo',
    null,
    (r, [key]: [string?]) => {
        r.call(HelpController).dismissVideo();
    }
);

export const inHaugCommands = () => inCommands(
    haugOpenVideo,
    haugDismissVideo,
);
